import Navbar from "../components/Navbar";

export default function Booking() {
  return (
    <>
 
      <section className="py-16 bg-slate-50">
        <div className="container mx-auto">

          <div className="text-center mb-10">
            <h1 className="text-5xl font-bold">
              Book Your Consultation
            </h1>

            <p className="mt-4 text-gray-600">
              Select your preferred date and time to schedule an appointment
              with Professor Vasha Kaur.
            </p>
          </div>

          <div
            className="bg-white rounded-2xl shadow-lg overflow-hidden"
            style={{ height: "900px" }}
          >
            <iframe
              src="https://professor-vasha-kaur.carebit.co/patients/bookings/new?clinician=ms-vasha-kaur"
              title="Book Appointment"
              width="100%"
              height="100%"
              style={{ border: 0 }}
            />
          </div>

        </div>
      </section>

     </>
  );
}